import { Injectable } from '@angular/core';
import { MenuItemModel } from '../../models/analytics/menu-item-model';
import { ItemIdModel } from '../../models/filter-model/item-id-model';
import { ChangeViewerLibrary } from '../../models/regulation/change-viewer-library';
import { UserProfile } from '../../models/user';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserService {
menueItems: Array<MenuItemModel>=[];
isLibraryCallingFirstTime:boolean=true;
  userInfo!: UserProfile;
isUserInfoFistTime:boolean=true;
userJurisdiction: Array<ItemIdModel>=[];
userLibrary: Array<ChangeViewerLibrary>=[];
  constructor() {
    this.menueItems=[];
  }



  getCurrentUser(): Promise<UserProfile> {
    return new Promise<UserProfile>((resolve: any, reject: any) => {
    });
  }
  private isEditorDataChange = new Subject<boolean>();
  message$ = this.isEditorDataChange.asObservable();

  sendMessage(message: boolean) {
    this.isEditorDataChange.next(message);
  }
}
